import * as util from "../apiUtils";
import * as common from "../apiCommon";
import * as DocType from "../../constants/constant_doc_types";


export function fetchDeviceById(app, params) {
  const { id } = params;
  return common.getDoc(
    app,
    { id, docType: DocType.DEVICE },
    { assemble_custom_fields: true },
  );
}

export function fetchDeviceDropdown(app, params) {
  const { searchTerm, searchParams, fields, id } = params;
  const dropdown_type = 'device/dropdown';
  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export function fetchDeviceStatusDropdown(app, params) {
  const {
    searchTerm,
    searchParams,
    fields,
    id,
  } = params;
  const dropdown_type = 'device_status/dropdown';

  const query = {
    id,
    dropdown_type,
    fields,
    searchTerm,
    searchParams
  };

  return common.getDropdownList(app, { query });
}

export async function saveDevice(app, dataToSave) {
  const { user = {}, data } = dataToSave;

  let deviceData = {
    doc_type: DocType.DEVICE,
    device_reference: util.toStringText(data.device_reference),
    name: util.toStringText(data.name),
    short_name: util.toStringText(data.short_name),
    device_type_id: data.device_type_id,
    location_id: data.location_id,
    parent_id: data.parent_id,
    active: util.toBoolean(data.active),
    attached_devices: data.attached_devices,
    employees: data.employees,
    status_id: data.status_id,
    signature_id: data.signature_id,
    merchant_id: data && data.merchant_id,
    terminal_id: data && data.terminal_id,
    integration_key: data && data.integration_key,
    subsidiary_id: data.subsidiary.id,
    currency_id: data.currency.id,
    printer_id: data.printer_id,
    online_customer_search: util.toBoolean(data.online_customer_search),
    pairing_config: data.pairing_config,
    custom_fields: data.custom_fields,
  };

  (deviceData.attached_devices || []).forEach( attachedDevice => {
    delete attachedDevice.onEditMode;
    delete attachedDevice.id;
    delete attachedDevice.device;
    delete attachedDevice.device_type;
    delete attachedDevice.device_reference;
  });

  (deviceData.employees || []).forEach( employee => {
    delete employee.employee;
    delete employee.onEditMode;
  });

  const savedDevice = await common.saveDoc(app, {
    source: data,
    doc: deviceData,
    referenceField: ["device_id"],
    user
  });

  return savedDevice;
}

export async function deleteDevice(app, data) {
  const deletedDevice = await common.deleteDoc(app, {
    id: data.id,
    docType: DocType.DEVICE
  });
  return deletedDevice;
}
